import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/map';
import { timeout } from "rxjs/operator/timeout";


@Injectable()
export class SocialService {
    http: Http;

    todayDataChange = new Subject<void>();
    today = [];
    private todayData = [];


    constructor(http: Http) {
        this.http = http;
    }

    // Social Today
    fetchSocialToday(media) {
        this.http.get(`/api/social-today/${media}`)
            .map((response: Response) => {
                const data = response.json();
                this.today = [
                    [
                        {
                            "name": "Hace 7 días",
                            "series": data.today.sevenDaysAgo
                        },
                        {
                            "name": "Hoy",
                            "series": data.today.today_results
                        },
                        {
                            "name": "Facebook",
                            "series": data.today.facebook
                        },
                        {
                            "name": "Twitter",
                            "series": data.today.twitter
                        }
                    ],
                    [
                        {
                            "name": "7 días antes",
                            "series": data.yesterday.sevenYDaysAgo
                        },
                        {
                            "name": "Ayer",
                            "series": data.yesterday.yesterday_results
                        },
                        {
                            "name": "Facebook",
                            "series": data.yesterday.facebookY
                        },
                        {
                            "name": "Twitter",
                            "series": data.yesterday.twitterY
                        }
                    ],
                    [
                        {
                            "name": "7 días antes",
                            "series": data.last24h.sevenDaysAgoL24h
                        },
                        {
                            "name": "24h",
                            "series": data.last24h.l24h_results
                        },
                        {
                            "name": "Facebook",
                            "series": data.last24h.facebookL24h
                        },
                        {
                            "name": "Twitter",
                            "series": data.last24h.twitterL24h
                        }
                    ]
                ];
                return this.today;
            })
            .subscribe(
            (data) => {
                this.todayData = data;
                // console.log(this.todayData);
                setTimeout(() => this.todayDataChange.next(), 1000 * 10);
            }
            );
    }

    fetchVisitsToday() {
        return this.todayData[0];
    }
    fetchVisitsYesterday() {
        return this.todayData[1];
    }
    fetchVisitsLast24h() {
        return this.todayData[2];
    }



}


// WEBPACK FOOTER //
// /home/node/src/app/_services/social.service.ts